var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_988_185",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_988_185",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACeklEQVR4nO2cMW5TQRRFPxIVJT0lDR0tNVtgC/R+1xblb9kCLSUtJVvwBrIA0pIuTchDgJEcS0HBjP87nrlHuv38exT/60mUaTJ9Imkr6e08z0+qz2J+C8ldvkn6IOmFi2EI+ZWI+B4RXyLizTzPjyvPNiSHQg7kfI2I9xHxrPqcw/A3IXu5kfR5vV6/nqbpUfWZu+aBQvZzIendarV6Wn32LjlCyJ+Ps+uI+BgRL6ufoSuOFXKQraczS0h6OjOFpKczUIju5tLTmSUkd/F0hgnJvXg6w4Tk7l3j6UwSorvxdIYJyV3GvnUGCMh7Ps7GvHWuLl4PyzjTGVB2/kP6n86AkvPI9DmdAcXm/6S76VxdqNrm/KczoMQ8Qc53OgPKy1PlLKdzdWlaLucxnQFF5cJhT2dAQVkY3nQGlJLVQU3n6jLES+10BhSQxETEVcl0rn5wwbP4dK5+YMFjIRr82z7gwRMWv9RVLMGzV5j4i6HqJfjqRIz4clHFEnz9rsG/Zbegujy1jX+FWy0hSDe1LaguVD1N1hYAis1uJmsLACVnN5O1BYCy857cnt1fjLQAUHx2M1lbUC1APU3WFhT/NFx3NVlbUCTjosvJ2oIFJdx0P1lbsICIy2EmawtOJOF2yMnagsYv6auhJ2sLGsnYerIWC/k5WSV9iohXrc5i/C/+eHiywvBkheHJChey2WyeV59paA6FVJ9neCwEhoXAsBAYFgLDQmBYCAwLgWEhMCwEhoXAsBAYFgLDQmBYCAwLgWEhMCwEhoXAsBAYFgLDQmBYCAwLgWEhMCwEhoXAsBAYFgLDQmBYCAwLgWEhMCwEhoXAsBBjzHRyfgCEjy6SK02iWQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUnselected);
export default __webpack_public_path__ + "static/media/flag_unselected.27e9db106b13fe2a9205e347bb0a4ec6.svg";
export { ForwardRef as ReactComponent };